import { Box, FormControl, FormHelperText, Grid2, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import React from "react";

function BasicSelect(props) {
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={props.documentType}
        label="Tipo"
        onChange={props.handleChange}
        autoFocus
      >
        {props.options.map((option) =>
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
}

const regularizationOptions = [
  {
    value: "credit-note",
    label: "Nota de crédito"
  },
  {
    value: "dispatch-guide",
    label: "Guía de despacho"
  },
]

const DeliveryRegularization = (props) => {
  // props brings the documentType and documentNumber from the backend if present
  const [documentType, setDocumentType] = React.useState(props.regularizationData?.documentType || "dispatch-guide");
  const [documentNumber, setDocumentNumber] = React.useState(props.regularizationData?.documentNumber || "");
  const [regularizationOptions, setRegularizationOptions] = React.useState(props.regularizationData?.regularizationOptions|| []);
  // Cannot read properties of undefined (reading 'filter')
  // TypeError: Cannot read properties of undefined (reading 'filter')
  const [labelDocumentType, setLabelDocumentType] = React.useState(props.regularizationData?.regularizationOptions?.filter(option => option.value === documentType)[0]?.label);

  const handleInfoToSend = props.handleInfoToSend;
  const setDisabledSaveBtn = props.setDisabledSaveBtn;
  if (props.originalDocumentType) {
    setDocumentType(props.originalDocumentType)
  }
  if (props.originalDocumentNumber) {
    setDocumentNumber(props.originalDocumentNumber)
  }
  
  const handleChange = (event) => {
    setDocumentType(event.target.value);
    handleInfoToSend({regularization: {documentType: event.target.value, documentNumber: documentNumber}})
    setDisabledSaveBtn(false);
  };
  const handleNumberChange = (event) => {
    setDocumentNumber(event.target.value);
    setDisabledSaveBtn(false);
    handleInfoToSend({regularization: {documentType: documentType, documentNumber: event.target.value}})
  };
  return (
    <div>
      <Typography variant="h5" component="div"> Documento </Typography>
      <br></br>
      {regularizationOptions.length > 0 &&
        <Box sx={{ flexGrow: 1 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={6}>
              <BasicSelect
                options={regularizationOptions}
                documentType={documentType}
                handleChange={(event) => handleChange(event)} />
            </Grid2>
            <Grid2 size={6}>
              <TextField
                fullWidth
                id="filled-basic"
                label={labelDocumentType}
                variant="filled"
                value={documentNumber}
                onChange={(event) => handleNumberChange(event)} />
              <FormHelperText id="filled-basic">Solo dígitos</FormHelperText>
            </Grid2>
          </Grid2>
        </Box>
      }
    </div>
  )
}

export default DeliveryRegularization;
